<template>
  <div class="table-width">
    <cTable
      :fields="fields"
      :modals="modals"
      :methods="methods"
      :footer="footer"
      :config="config"
      ref="table"
    >
    </cTable>
  </div>
</template>
<script>
import cTable from "@/base/common/index";
import { getB2BbillSplit } from "@/api/finance/b2b_details";
export default {
  props: {
    row: Array
  },
  components: {
    cTable
  },
  mounted() {
    this.$refs.table.list = this.row;
  },
  data() {
    return {
      config: {
        resize: false,
        slot: "div"
      },
      methods: {
        getB2BbillSplit
      },
      footer: {
        show: () => false
      },
      modals: {
        showUnPack: {
          config: {
            listFn: "getB2BbillSplit",
            modalBind: {
              width: 800
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              height: 600
            },
            footer: {
              show: true
            },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_number",
                tooltip: true,
                minWidth: 100
              }
            ]
          }
        }
      },
      fields: [
        {
          name: () => this.$t("orderNum"),
          width: 210,
          key: "airway_bill_number"
        },
        {
          name: () => this.$t("totalAeclaredAmount"),
          width: 215,
          key: "values"
        },
        {
          name: () => this.$t("wight"),
          key: "deliver_weight",
          minWidth: 130
        },
        {
          name: () => this.$t("gather") + this.$t("skuVolume"),
          key: "deliver_volume",
          minWidth: 100
        },
        {
          name: () => this.$t("cost_share"),
          key: "deliver_cost",
          minWidth: 100
        },
        {
          name: () => this.$t("charging_volume"),
          key: "charging_volume",
          minWidth: 100
        },
        {
          name: () => this.$t("mawb"),
          key: "packing",
          minWidth: 150
        },
        {
          name: () => this.$t("total_votes"),
          key: "deliver_order",
          minWidth: 100
        },
        {
          name: this.$t("operation"),
          type: "btns",
          width: 100,
          fixed: "right",
          list: [
            {
              name: () => this.$t("unpack") + this.$t("information"),
              type: "unpackmsg",
              fnName: "unpackmsgFn",
              bind: {
                type: "success"
              }
              // show({ row }) {
              //   return row.is_unpack == "YES";
              // }
            }
          ],
          methods: {
            unpackmsgFn({ row }) {
              this.getModal("showUnPack").open(null, function() {
                console.log(row);
                this.setTitle(
                  row.airway_bill_number +
                    this.$t("unpack") +
                    this.$t("information")
                );
                this.pageConfig.data = {
                  airway_number: row.airway_bill_number,
                  packing: row.packing
                };
                this.getList();
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style>
.table-width {
  width: 1400px;
  overflow: hidden;
}
.vxe-body--expanded-cell {
  background: #f5f5f5;
  padding: 20px 0;
}
</style>
